import { render, staticRenderFns } from "./financeiro-notificar-email.vue?vue&type=template&id=0bbdbc76&scoped=true"
import script from "./financeiro-notificar-email.vue?vue&type=script&lang=ts"
export * from "./financeiro-notificar-email.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-notificar-email.vue?vue&type=style&index=0&id=0bbdbc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbdbc76",
  null
  
)

export default component.exports